import PropTypes from 'prop-types';
import styles from './FJImageToImageLeft.module.less';
import FJGenerateQuantityContainer from '../FJGenerateQuantity/FJGenerateQuantityContainer';
import FJModalListContainer from '../FJModalList/FJModalListContainer';
import FJGenerateButton from '../../../common/components/FJGenerateButton/FJGenerateButton';
import FJAppLeft from '../../FJMainPreview/FJAppLeft/FJAppLeft';
import FJImageInputContainer from '../FJImageInput/FJImageInputContainer';
import FJPromptInputContainer from '../FJPromptInput/FJPromptInputContainer';
import { IMAGE_TO_IMAGE_USE_CREDIT } from '../../../redux/slices/FJSliceImageToImage';

const FJImageToImageLeft = props => {
    const { generateQuantity, onGenerate, taskStatus, isProjectLoading, freeNumCreation, creditNumber } = props;
    const useCredit = generateQuantity * IMAGE_TO_IMAGE_USE_CREDIT;
    const isFree = freeNumCreation > 0 && generateQuantity * 2 > creditNumber && generateQuantity < 3;
    return (
        <FJAppLeft className={styles.container}>
            <FJImageInputContainer id='imageToImageInput' />
            <FJModalListContainer id='imageToImageList' />
            <div className={styles.footer}>
                <FJPromptInputContainer />
                <FJGenerateQuantityContainer />
                <FJGenerateButton
                    onClick={onGenerate}
                    taskStatus={taskStatus}
                    freeNumCreation={freeNumCreation}
                    isFree={isFree}
                    useCredit={useCredit}
                    isProjectLoading={isProjectLoading}
                    isShowUsageDetail={true}
                    id='imageToImageBtn'
                />
            </div>
        </FJAppLeft>
    );
};
export default FJImageToImageLeft;
FJImageToImageLeft.propTypes = {
    generateQuantity: PropTypes.number,
    onGenerate: PropTypes.func,
    taskStatus: PropTypes.string,
    freeNumCreation: PropTypes.number,
    creditNumber: PropTypes.number,
    isProjectLoading: PropTypes.bool,
};
